export default "__VITE_ASSET__BTIDDTWK__"